<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'180px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('StockStructureConfiguration.Header.Name')" prop="name">
            <BjInput
              v-model="queryParams.name"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('StockStructureConfiguration.Header.Status')" prop="configureStatus">
            <BjSelectLov
              v-model="queryParams.configureStatus"
              :option-list="CONFIGURE_STATUS_TRUE"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('StockStructureConfiguration.Header.Create') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <template v-else-if="col.prop === 'configureStatus'">
                {{ $t(CONFIGURE_STATUS_TRUE.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'releaseStatus'">
                {{ $t(RELEASE_STATUS_TRUE.bjGet(scope.row[col.prop])) }}
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            fixed="right"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingStockStructureView
                type="text"
                @click="onSet(props.row)"
                >{{ $t('StockStructureConfiguration.Header.Action') }}</el-button
              >
              <el-button
                v-show="props.row.releaseStatus"
                v-permission:SettingStockStructureIndex_Close
                type="text"
                @click="onStatus(false, props.row)"
                >{{ $t('StockStructureConfiguration.Header.Cancel') }}</el-button
              >
              <el-button
                v-if="!props.row.releaseStatus"
                v-permission:SettingStockStructureIndex_Release
                type="text"
                @click="onStatus(true, props.row)"
                >{{ $t('StockStructureConfiguration.Header.Publish') }}</el-button
              >
              <el-button
                v-if="!props.row.releaseStatus"
                v-permission:SettingStockStructureIndex_Delete
                type="text"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 添加库存初始化弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { RELEASE_STATUS_TRUE, CONFIGURE_STATUS_TRUE } from '@/utils/constants';
const getDefaultForm = () => {
  return {
    configureStatus: null,
  };
};

export default {
  name: 'SettingStockStructureIndex',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      RELEASE_STATUS_TRUE,
      CONFIGURE_STATUS_TRUE,
      queryApi: stockApi.getWarehouseStructures,
      // 查询参数
      queryParams: {
        configureStatus: null,
        name: null,
      },
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelList: [
        { label: 'StockStructureConfiguration.table.Code', prop: 'code', isCheck: true, disabled: false, width: 272 },
        { label: 'StockStructureConfiguration.table.Name', prop: 'name', isCheck: true, disabled: false, width: 277 },
        { label: 'StockStructureConfiguration.table.status', prop: 'configureStatus', isCheck: true, disabled: false, width: 280 },
        { label: 'StockStructureConfiguration.table.Release', prop: 'releaseStatus', isCheck: true, disabled: false, width: 112 },
        { label: 'StockStructureConfiguration.table.by', prop: 'createdName', isCheck: true, disabled: false },
        { label: 'StockStructureConfiguration.table.time', prop: 'creationDate', isCheck: true, disabled: false, width: 138 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 252 },
      ],
      colSpan: 8,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        alert('submit!');
      });
    },
    /** 创建库存 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 结构设置 */
    onSet(row) {
      this.$toPage('SettingStockStructureView', { structureId: row.id });
    },
    /** 下架  发布*/
    onStatus(flag, row) {
      if (flag && !row.configureStatus) {
        // 要发布，但没有配置好  请先
        this.$alert('请先配置仓库结构', this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          callback: action => {},
        });
        return;
      }
      this.operationApi({
        id: row.id,
        flag: flag,
        objectVersionNumber: row.objectVersionNumber,
      });
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi(row);
        })
        .catch(() => {});
    },
    deleteApi(API_DATA) {
      stockApi.deleteWarehouseStructures(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    operationApi(API_DATA) {
      stockApi.statusWarehouseStructures(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
